import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { BarcodeScannedAction, ScannerFacade } from '../+state';
import { ScanMode } from '../models';

@Injectable()
export class ShowScannerGuard implements CanActivate {
  constructor(private scannerFacade: ScannerFacade) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const scanMode = route.data.scanMode as ScanMode;
    const actionToDispatch = route.data.actionToDispatchOnBarcodeScanned as BarcodeScannedAction;
    this.scannerFacade.showScannerCamera(scanMode, actionToDispatch);

    return true;
  }
}
